import TextExpandablePanel from '@/features/text-expandable-panel';
import SafeHtml from '@/components/safe-html';
import { GIFT_CARD_FAQ_DATA } from './constant';
const FAQQuestions = () => {
  return <div className='flex flex-col gap-2' data-sentry-component="FAQQuestions" data-sentry-source-file="faq-questions.tsx">
            {GIFT_CARD_FAQ_DATA?.map((faq, faqIndex) => {
      return <TextExpandablePanel className='rounded border-none bg-surface-solid-50 text-caption-12 font-medium' hasFocusStyle title={faq.question} key={faqIndex} uniqueKey={`faq-${faqIndex}-${faqIndex}`}>
                        <SafeHtml as='p' content={faq.answer} />
                    </TextExpandablePanel>;
    })}
        </div>;
};
export default FAQQuestions;